// Curated 5-letter answer words for Wordle / Quordle / Sedecordle.
// Kept tight on purpose - everyday English, no plurals ending in S of nouns,
// no proper nouns, no extreme rarities. The original 2022 prototype used 26
// per-letter files; this file replaces that with one bundled list.

const ANSWERS = [
  'abbey','about','above','abuse','actor','acute','admit','adopt','adult','after',
  'again','agent','agile','agree','ahead','alarm','album','alert','alien','align',
  'alike','alive','allow','alloy','alone','along','aloud','alpha','altar','amber',
  'amend','among','ample','amuse','angel','anger','angle','angry','ankle','apart',
  'apple','apply','april','arena','argue','arise','armor','aroma','arose','array',
  'arrow','aside','asset','atlas','audio','audit','avoid','await','awake','award',
  'aware','badge','baker','bakes','balmy','banjo','barge','basic','basil','basin',
  'batch','beach','beans','beard','beast','beech','began','begin','begun','being',
  'below','bench','berry','bible','bicep','bingo','birch','birth','black','blade',
  'blame','blank','blast','blaze','bleak','bleed','blend','bless','blind','blink',
  'bliss','block','blond','blood','bloom','blown','bluer','blunt','blurb','blurt',
  'blush','board','boast','bonus','boost','booth','booty','borax','bound','brace',
  'braid','brain','brake','brand','brass','brave','bread','break','breed','briar',
  'bribe','brick','bride','brief','brine','bring','briny','brisk','broad','broil',
  'broke','brood','brook','broom','broth','brown','brunt','brush','bunch','burly',
  'cable','cabin','cache','caddy','cadet','camel','candy','canoe','carat','cards',
  'cargo','carry','carve','catch','cause','cease','cedar','chair','chalk','chant',
  'chaos','charm','chart','chase','cheap','cheat','check','cheek','cheer','chess',
  'chest','chief','child','chili','chill','chime','china','chips','chirp','choir',
  'choke','chord','chose','chrome','chunk','chute','cider','cigar','cinch','civic',
  'civil','claim','clamp','clang','clash','clasp','class','clean','clear','clerk',
  'click','cliff','climb','cling','clink','cloak','clock','clone','close','cloth',
  'cloud','clout','clove','clown','clued','clump','clung','coach','coast','cobra',
  'cocoa','color','comet','comic','comma','conch','copay','coral','corps','couch',
  'cough','could','count','coupe','court','coven','cover','covet','crack','craft',
  'crane','crash','crate','crave','crawl','crazy','cream','creed','creek','creep',
  'crepe','crest','crew','cried','crime','crisp','croak','crock','crone','crony',
  'crook','cross','crowd','crown','crude','cruel','crumb','crush','crust','crypt',
  'cubic','curse','curve','daddy','daily','dairy','dance','dandy','dared','dates',
  'dealt','death','debug','debut','decal','decay','decoy','defer','deign','delay',
  'delta','delve','demon','dense','depot','depth','derby','devil','diary','dicey',
  'digit','dimly','dined','diner','dingo','dingy','dirty','disco','ditch','ditty',
  'diver','dizzy','dodge','dogma','doing','donor','dough','dowry','dozen','draft',
  'drain','drake','drama','drank','drape','drawl','drawn','dread','dream','dress',
  'dried','drift','drill','drily','drink','drive','droll','drone','drool','drove',
  'drown','druid','drunk','dryer','duchy','dummy','dunce','dusty','dwarf','dwell',
  'eager','eagle','early','earth','easel','eaten','eater','eclat','edge','eight',
  'eject','elbow','elder','elect','elegy','elfin','elide','elite','elope','elude',
  'email','embed','ember','emcee','empty','enact','endow','enemy','enjoy','enter',
  'entry','envoy','epoch','equal','erase','erect','erode','error','erupt','essay',
  'ester','ether','ethic','event','every','evict','evoke','exact','exalt','excel',
  'exert','exile','exist','extol','extra','exult','fable','facet','faint','fairy',
  'faith','false','fancy','fault','favor','feast','fence','ferry','fetch','fever',
  'fewer','fiber','field','fiery','fifth','fifty','fight','filer','filet','final',
  'finch','finer','first','fiver','fixer','fizzy','fjord','flair','flake','flame',
  'flank','flare','flash','flask','fleck','fleet','flesh','flick','flier','fling',
  'flint','flirt','float','flock','flood','floor','flora','flour','flown','fluff',
  'fluid','flung','flush','flute','focus','foggy','foray','force','forge','forte',
  'forth','forty','forum','found','foyer','frail','frame','frank','fraud','freak',
  'fresh','friar','fried','frill','frizz','frock','front','frost','froth','frown',
  'froze','fruit','fudge','fully','fungi','funky','funny','furor','fussy','fuzzy',
  'gable','gamer','gamma','gauge','gaunt','gauze','gavel','gawky','gazed','gecko',
  'geeky','genie','genre','ghost','ghoul','giant','girly','given','giver','glade',
  'glare','glass','glaze','gleam','glean','glide','glint','globe','gloom','glory',
  'gloss','glove','glyph','gnash','gnome','going','goose','gouge','grade','graft',
  'grain','grand','grant','grape','graph','grasp','grass','grate','grave','gravy',
  'graze','great','greed','green','greet','grief','grill','grime','grimy','grind',
  'gripe','groan','groin','groom','gross','group','grout','grove','growl','grown',
  'gruel','gruff','grunt','guard','guess','guest','guide','guild','guile','guilt',
  'gulch','gully','gummy','gusto','gusty','gypsy','habit','hairy','halve','handy',
  'happy','hardy','harem','harpy','harsh','hasty','hatch','hater','haunt','haven',
  'havoc','hazel','heady','heart','heath','heave','heavy','hedge','hefty','helix',
  'hello','hence','heron','hertz','hippo','hippy','hitch','hoard','hobby','hoist',
  'holly','homer','honey','honor','horde','horse','hotel','hound','house','hover',
  'howdy','human','humid','humor','humph','humus','hunch','hurry','husky','hutch',
  'hyena','hymen','hyper','icily','icing','ideal','idiom','idiot','idler','idyll',
  'igloo','image','imbue','impel','imply','inane','inbox','incur','index','inert',
  'infer','ingot','inlay','inlet','inner','input','inter','intro','ionic','irate',
  'irony','islet','issue','itchy','ivory','jaded','japan','jaunt','jazzy','jelly',
  'jerky','jetty','jewel','jiffy','joint','joist','joker','jolly','joust','judge',
  'juice','juicy','jumbo','jumpy','jurat','juror','kappa','karma','kayak','kebab',
  'khaki','kinky','kiosk','kitty','knack','knave','knead','kneel','knelt','knife',
  'knock','knoll','known','koala','krill','label','labor','laden','ladle','lager',
  'lance','lanky','lapel','lapse','large','larva','laser','lasso','latch','later',
  'lathe','laugh','layer','leafy','leaky','leant','leapt','learn','lease','leash',
  'least','leave','ledge','leech','leery','lefty','legal','lemon','leper','level',
  'lever','libel','lifer','light','liken','lilac','limbo','liner','lingo','lipid',
  'liver','livid','llama','lobby','local','locus','lodge','lofty','logic','login',
  'loopy','loose','lorry','loser','louse','lousy','lover','lower','loyal','lucid',
  'lucky','lumen','lumpy','lunar','lunch','lunge','lupus','lurch','lurid','lusty',
  'lying','lymph','lyric','macaw','macho','macro','madam','madly','mafia','magic',
  'magma','maize','major','maker','mambo','mango','mangy','mania','manly','manor',
  'maple','march','marry','marsh','mason','match','matey','mauve','maxim','maybe',
  'mayor','meant','medal','media','medic','melee','melon','mercy','merge','merit',
  'merry','metal','meter','metro','micro','midge','midst','might','minty','minus',
  'mirth','misty','mixed','mixer','model','modem','mogul','moist','molar','moldy',
  'money','month','moose','moral','moron','morph','motel','motif','motor','motto',
  'mossy','mould','mound','mount','mourn','mouse','mouth','mover','movie','mower',
  'mucus','muddy','mulch','mummy','munch','mural','murky','mushy','music','musky',
  'musty','myrrh','nadir','naive','nasal','nasty','natal','naval','navel','needy',
  'nerdy','nerve','never','newer','newly','nicer','niche','niece','night','nimbi',
  'ninja','ninth','noble','nobly','noise','noisy','nomad','noose','north','nosey',
  'notch','novel','nudge','nurse','nutty','nylon','nymph','oaken','oasis','occur',
  'ocean','octal','octet','offal','offer','often','olden','olive','ombre','omega',
  'onion','onset','opera','opine','opium','optic','orbit','order','organ','other',
  'otter','ought','ounce','outdo','outer','outgo','ovary','ovate','overt','ovine',
  'owing','owner','oxide','ozone','paddy','pagan','paint','paler','palmy','panel',
  'panic','pansy','paper','parka','parry','parse','party','pasta','paste','pasty',
  'patch','patio','pause','payee','payer','peace','peach','pearl','pecan','pedal',
  'penny','perch','peril','perky','petal','petit','petty','phase','phone','phony',
  'photo','piano','picky','piece','piety','piggy','pilot','pinch','piney','pinky',
  'pinto','piper','pique','pithy','pivot','pixel','pixie','pizza','place','plaid',
  'plain','plait','plane','plank','plant','plate','plaza','plead','pleat','plied',
  'plier','pluck','plumb','plume','plump','plunk','plush','poesy','point','poise',
  'poker','polar','polka','polyp','poppy','porch','poser','posit','posse','pouch',
  'pound','pouty','power','prank','prawn','preen','press','price','prick','pride',
  'pried','prime','primo','print','prior','prism','privy','prize','probe','prone',
  'prong','proof','prose','proud','prove','prowl','proxy','prude','prune','psalm',
  'pubic','pudgy','pulpy','pulse','punch','pupil','puppy','puree','purer','purge',
  'purse','pushy','putty','pygmy','quack','quail','quake','qualm','quark','quart',
  'quash','quasi','queen','queer','quell','query','quest','queue','quick','quiet',
  'quill','quilt','quirk','quite','quoth','rabid','racer','radar','radio','rainy',
  'raise','rajah','rally','ralph','ramen','ranch','randy','range','rapid','rarer',
  'raspy','ratio','raven','rayon','razor','reach','react','ready','realm','rearm',
  'rebar','rebel','rebut','recap','recur','reedy','refer','rehab','reign','relax',
  'relay','renal','renew','repay','repel','reply','reset','resin','retch','retro',
  'retry','reuse','revel','revue','rhino','rhyme','rider','ridge','rifle','right',
  'rigid','rinse','ripen','riper','risen','riser','risky','rival','river','rivet',
  'roach','roast','robin','rocky','rogue','roomy','roost','rotor','rouge','rough',
  'round','rouse','route','rowdy','royal','rugby','ruler','rumor','rural','rusty',
  'sadly','safer','saint','salad','salon','salsa','salty','salve','sandy','sappy',
  'sassy','satin','satyr','sauce','saucy','sauna','saute','savor','savoy','savvy',
  'scald','scale','scalp','scaly','scamp','scant','scare','scarf','scary','scene',
  'scent','scion','scoff','scold','scone','scoop','scope','score','scorn','scour',
  'scout','scowl','scram','scrap','scree','screw','scrub','scuba','scuff','sedan',
  'seedy','segue','seize','semis','sense','sepia','serif','serum','serve','setup',
  'seven','sever','sewer','shack','shade','shady','shaft','shake','shaky','shale',
  'shall','shalt','shame','shank','shape','share','shark','sharp','shave','shawl',
  'shear','sheen','sheep','sheer','sheet','sheik','shelf','shell','shied','shift',
  'shine','shiny','shire','shirk','shirt','shoal','shock','shoot','shore','shorn',
  'short','shout','shove','shown','showy','shrew','shred','shrub','shrug','shuck',
  'shunt','shush','shyly','sibyl','sided','sieve','sight','sigma','silky','silly',
  'since','sinew','singe','sissy','siren','sissy','sixth','sixty','skate','skier',
  'skiff','skill','skimp','skirt','skull','skunk','slack','slain','slake','slang',
  'slant','slash','slate','sleek','sleep','sleet','slept','slice','slick','slide',
  'slime','slimy','sling','slink','sloop','slope','slosh','sloth','slump','slung',
  'slunk','slurp','slush','small','smart','smash','smear','smell','smelt','smile',
  'smirk','smite','smith','smoke','smoky','snack','snail','snake','snare','snarl',
  'sneak','sneer','snide','sniff','snipe','snoop','snore','snort','snout','snowy',
  'snuck','snuff','soapy','sober','soggy','solar','solid','solve','sonar','sonic',
  'sooth','sooty','sorry','sound','south','sower','space','spade','spank','spare',
  'spark','spasm','spawn','speak','spear','speck','speed','spell','spelt','spend',
  'spent','sperm','spice','spicy','spied','spiel','spike','spiky','spill','spine',
  'spiny','spiral','spire','spite','splat','split','spoil','spoke','spook','spool',
  'spoon','spore','sport','spout','spray','spree','sprig','spry','spunk','spurn',
  'spurt','squad','squat','stack','staff','stage','staid','stain','stair','stake',
  'stale','stalk','stall','stamp','stand','stank','stare','stark','start','stash',
  'state','stave','stead','steak','steal','steam','steed','steel','steep','steer',
  'stein','stern','stick','stiff','still','stilt','sting','stink','stint','stock',
  'stoic','stoke','stole','stomp','stone','stony','stood','stool','stoop','store',
  'stork','storm','story','stout','stove','strap','straw','stray','strep','strew',
  'strip','strut','stub','stuck','study','stuff','stump','stung','stunk','stunt',
  'style','suave','sugar','suing','suite','sulky','sully','sumac','sunny','super',
  'surer','surge','surly','sushi','swami','swamp','swank','swarm','swash','swath',
  'swear','sweat','sweep','sweet','swell','swept','swift','swill','swine','swing',
  'swirl','swish','sword','swore','sworn','swung','syrup','table','taboo','tacit',
  'tacky','taffy','taken','taker','tally','talon','tamer','tango','tangy','taper',
  'taps','tardy','tarot','taste','tasty','tatty','taunt','tawny','teach','tease',
  'teddy','teeth','tempo','tenet','tenor','tense','tepee','tepid','terra','terse',
  'tertiary','testy','thank','theft','their','theme','there','these','theta',
  'thick','thief','thigh','thing','think','third','thong','thorn','those','three',
  'threw','throb','throw','thrum','thumb','thump','thyme','tiara','tibia','tidal',
  'tiger','tight','tilde','timer','tipsy','titan','tithe','title','toast','today',
  'token','tonal','tonic','topic','torch','torso','torte','toxic','toxin','trace',
  'track','tract','trade','trail','train','trait','tramp','trash','trawl','tread',
  'treat','trend','tress','triad','trial','tribe','trice','trick','tried','tripe',
  'trite','troll','troop','trope','trout','trove','truce','truck','truer','truly',
  'trump','trunk','truss','trust','truth','tryst','tubal','tuber','tulip','tumor',
  'tuned','tuner','tunic','turbo','tutor','twang','tweak','tweed','tweet','twice',
  'twine','twirl','twist','tying','udder','ulcer','ultra','umbra','uncle','uncut',
  'under','undue','unfed','unfit','unify','union','unite','unity','unlit','unmet',
  'unset','until','unwed','unzip','upper','upset','urban','urine','usage','usher',
  'using','usual','utile','utter','vague','vain','valet','valid','value','valve',
  'vapid','vapor','vault','vaunt','vegan','venom','venue','verge','verse','verso',
  'verve','vests','vetch','vexed','vials','vicar','video','vigil','vigor','villa',
  'vinyl','viola','viral','virus','visit','visor','vista','vital','vivid','vixen',
  'vocal','vodka','vogue','voice','voila','vomit','voter','vouch','vowel','vroom',
  'vying','wacky','wafer','wager','wages','wagon','waist','waive','waltz','warty',
  'waste','watch','water','waved','waver','waxen','weary','weave','wedge','weedy',
  'weigh','weird','welch','wench','whack','whale','wharf','wheat','wheel','whelp',
  'where','which','whiff','while','whine','whiny','whirl','whisk','white','whole',
  'whose','widen','wider','widow','width','wield','wight','wimpy','wince','winch',
  'windy','wiser','wispy','witch','witty','woken','woman','women','woody','wooer',
  'wooly','woozy','wordy','world','worry','worse','worst','worth','would','wound',
  'woven','wrack','wrath','wreak','wreck','wrest','wring','wrist','write','wrong',
  'wrote','wrung','wryly','yacht','yearn','yeast','yield','young','youth','yucca',
  'yummy','zebra','zesty','zilch','zonal','zonk','zoned','zooid','zoner','zoom'
];

// De-dupe, force lowercase, and strip anything that isn't 5 letters.
const set = new Set();
const list = [];
for (const w of ANSWERS) {
  if (typeof w !== 'string') continue;
  const k = w.toLowerCase();
  if (k.length !== 5 || /[^a-z]/.test(k) || set.has(k)) continue;
  set.add(k);
  list.push(k);
}

const ANSWER_LIST = list;
export default ANSWER_LIST;
export { ANSWER_LIST };
